const addFavorite = () => {
    const heart = document.querySelectorAll('.item__favorite');
    if(heart) {
        heart.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                item.children[0].src='./icons/products/favorite.svg'
                
            })
        })
    }
}

export default addFavorite;